import { Button, Elevation, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import Text from '../../../components/Text';
import EventCreateOverlay from '../components/EventCreateOverlay';
import EventList from '../components/EventList';
import EventListFilter from '../components/EventListFilter';
import EventListSorter from '../components/EventListSorter';

const EventListPage = () => {
  const navigate = useNavigate();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const onCreated = (modelId: string) => {
    AppToaster.success('Veranstaltung hinzugefügt!');
    navigate(`/events/${modelId}`);
  };

  return (
    <ContentCard elevation={Elevation.TWO} className="mb-5">
      <EventCreateOverlay
        isOpen={isCreateDialogOpen}
        onSuccess={onCreated}
        onClose={() => setIsCreateDialogOpen(false)}
      />
      <ContentCardHeader
        leftElement={
          <>
            <Text large className="mr-2">
              Veranstaltungen
            </Text>
            <EventListFilter />
            <EventListSorter />
          </>
        }
        rightElement={
          <Button
            text="Hinzufügen"
            icon={IconNames.ADD}
            intent={Intent.PRIMARY}
            className="ml-2"
            onClick={() => setIsCreateDialogOpen(true)}
          />
        }
      />
      <EventList />
    </ContentCard>
  );
};

export default EventListPage;
